import { forwardRef, type SVGProps } from 'react';

export type PanelLeftIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const PanelLeftIcon = forwardRef<SVGSVGElement, PanelLeftIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 32 32">
    <path
      d="M26.87 3H5.13C4.56509 3 4.02331 3.22441 3.62386 3.62386C3.22441 4.02331 3 4.56509 3 5.13V26.87C3 27.4349 3.22441 27.9767 3.62386 28.3761C4.02331 28.7756 4.56509 29 5.13 29H26.87C27.4349 29 27.9767 28.7756 28.3761 28.3761C28.7756 27.9767 29 27.4349 29 26.87V5.13C29 4.56509 28.7756 4.02331 28.3761 3.62386C27.9767 3.22441 27.4349 3 26.87 3ZM5.38 5.38H11.28V26.62H5.38V5.38ZM26.62 26.62H13.46V5.38H26.62V26.62Z"
      fill="currentColor"
    />
  </svg>
));

PanelLeftIcon.displayName = 'PanelLeftIcon';
